import { constants } from "caradvise_shared_components"
import store from "../../shared_component/utils/configureStore"
import { getActiveVehicle } from "./vehicleHelpers"
import { isEbay } from "./affiliationHelpers"

const {
  orders: { INITIATED_BY_USER, ACTIVE, AWAITING_APPROVAL, COMPLETED, PAID, APPROVAL }
} = constants

// TODO: This deprecated status is still coming back from a serializer in the api.
// Need to go through and get rid of its usage.
const DEPRECATED_APPROVED = "approved"
const AWAITING_APPROVAL_LABEL = "Needs Approval"
const INITIATED_LABEL = "Initiated"
const APPROVED_LABEL = "Approved"
const COMPLETED_LABEL = "Completed"

export function isApproved(order) {
  if (order == null) return false

  return [APPROVAL, DEPRECATED_APPROVED].indexOf(order.status) != -1
}

export const getActiveOrder = () => {
  let activeOrder
  const state = store.getState()
  const activeVehicle = getActiveVehicle()
  const activeOrders =
    state.user && state.user.active_orders && state.user.active_orders.length
      ? state.user.active_orders
      : []
  activeOrder =
    activeVehicle && activeOrders.find(({ vehicle_id }) => vehicle_id === activeVehicle.id)
  return activeOrder || null
}

export const isWalkIn = (order) => {
  if (order && order.appointment_time_pretty) {
    return order.appointment_time_pretty.includes("3:00 AM")
  }
  return false
}
export const getUpdatedCart = (user, order, props, isCartFlag = false) => {
  let isCart
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  let newOrder =
    (user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)) ||
    currentActiveOrder
  if (order) {
    cart = newOrder
    isCart = isCartFlag ? true : false
  } else if (currentActiveOrder) {
    cart = currentActiveOrder
    isCart = false
  } else {
    isCart = true

    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }
  return {
    cart: cart,
    isCart: isCart
  }
}

export const getOrderStatus = (order) => {
  if ([INITIATED_BY_USER, ACTIVE].includes(order.state)) return INITIATED_LABEL
  else if (order.state == AWAITING_APPROVAL) return AWAITING_APPROVAL_LABEL
  else if ([COMPLETED, PAID].includes(order.state)) return COMPLETED_LABEL
  else if ([APPROVAL].includes(order.state)) return APPROVED_LABEL
}

export const isEbayTireOrder = (cart) => {
  return (
    isEbay() &&
    Boolean(
      cart?.order_services?.some((service) => service.name.toLowerCase().includes("tire install"))
    )
  )
}

export const promotionsSummaryLabel = (order, fallbackLabel = "Promo discount") => {
  const promotions = order?.promotions || []
  if (promotions.length === 0 || promotions.some((promotion) => !promotion?.name)) {
    return fallbackLabel
  }
  return promotions
    .map((promotion) =>
      promotion.discount_type === "percent" && Number(promotion.discount) > 0
        ? `${promotion.name} (${Math.round(Number(promotion.discount))}%)`
        : promotion.name
    )
    .join(" + ")
}

// the order details endpoint returns numeric statuses on v4 and strings on v6
const COMPLETED_SERVICE_STATUSES = [2, 5, "approved", "completed"]

export const getCompletedServices = (order) =>
  (order?.order_services || []).filter((service) =>
    COMPLETED_SERVICE_STATUSES.includes(service?.status)
  )

// maps the v6 order details response onto the field names the receipt renders off of
export const normalizeOrderResponse = (order) => {
  if (!order) return order

  const miles = Number(order.miles || 0)
  const vehicle = order.vehicle || {}

  return {
    ...order,
    appointment_datetime: order.appointment_date_pretty,
    estimated_total_pre_tax: order.pre_tax_sub_total,
    total_after_promos: order.override_total,
    redeem_discount: order.redeem_reward,
    estimated_savings: order.total_savings,
    vehicle: {
      ...vehicle,
      odometer_config:
        miles > 0 ? { display_value_abbr: `${miles.toLocaleString()} mi` } : undefined
    }
  }
}

export const getReceiptPricing = (order = {}) => {
  const subTotal = Number(order?.estimated_total_pre_tax || 0)
  const promotionalDiscount = Number(order?.promotional_discount || 0)
  const membershipDiscount = Number(order?.membership_discount || 0)
  const rewardsDiscount = Number(order?.redeem_discount || 0)
  const servicesTotal = Number(order?.services_total || 0)
  const totalAfterPromos = Number(order?.total_after_promos || 0)

  return {
    servicesTotal,
    promotionalDiscount,
    totalAfterPromos,
    membershipDiscount,
    membershipPercent:
      totalAfterPromos > 0 ? Math.round((membershipDiscount / totalAfterPromos) * 100) : 0,
    rewardsDiscount,
    subTotal,
    taxes: Number(order?.estimated_tax_total || order?.tax_amount || 0),
    networkSurcharge: Math.max(0, Number(order?.network_surcharge || 0)),
    surchargePercent: Math.round(Number(order?.applicable_surcharge_percent || 0))
  }
}
